
// 在这里获取当前用户输入的域名 然后将域名替换到环境变量
let domain = window.location.hostname

let wsUrl = ''
let serveUrl = ''

// 使用新的函数提取主域名
// const mainDomain = getMainDomainByRegex(domain)

// domain = mainDomain

if (domain === 'localhost') domain = import.meta.env.VITE_APP_DEFAULT_DOMAIN
wsUrl = import.meta.env.VITE_APP_WS_URL.replace('{domain}', domain)
serveUrl = import.meta.env.VITE_APP_BASE_URL.replace('{domain}', domain)

const iosDdUrl = import.meta.env.VITE_APP_IOSDDURL
const bftLink = 'https://etherscan.io/token/0x2e9562358a7e3235f9caff0a2bead09205faa3d2'

export {
  wsUrl,
  serveUrl,
  iosDdUrl,
  bftLink,
}
